exports.install = function (Vue, options) {
    Vue.prototype.transHouseType = data => {
        switch (data) {
            case 1 : return '整層住家'
            case 2 : return '套房'
            case 3 : return '雅房'
        }
    }
    Vue.prototype.chageNunToChinese = data => {
        switch (data) {
            case 0 : return '零'
            case 1 : return '一'
            case 2 : return '二'
            case 3 : return '三'
            case 4 : return '四'
            case 5 : return '五'
            case 6 : return '六'
            case 7 : return '七'
            case 8 : return '八'
            case 9 : return '九'
            case 10 : return '十'
        }
    }
    Vue.prototype.toCurrency = data => {
        if(data != undefined){
            var parts = data.toString().split('.');
            // console.log(parts);
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return parts.join('.');
        }
        
    }
    Vue.prototype.transSource = value => {
        if( value === 'BOOKING_DEPOSIT' ){
            return '訂金'
        }else if( value === 'CONTRACT_DEPOSIT' ) {
            return '押金'
        }else if( value === 'CONTRACT_BILL' ) {
            return '租金雜項'
        }else if( value === 'HOUSE_TASK_BONUS' ) {
            return '委託獎金'
        }else if(value === 'HOUSE_LEDGER'){
            return '收入記帳'
        }else if(value === 'RETURN_PAID_HOUSE_TASK_BONUS'){
            return '委託退款'
        }else if(value === 'BOOKING_DEPOSIT_FOR_TENANT_REJECT'){
            return '取消預定'
        }else if(value === 'USER_DEPOSIT'){
            return '儲值'
        }else if(value === 'WITHDRAW'){
            return '提領'
        }
    }
    Vue.prototype.houseStatus = value => {
        if( value === 'DISCARD' ){
            return '棄用'
        }else if( value === 'REVEAL' ) {
            return '未租'
        }else if( value === 'LOCK' ) {
            return '預定中'
        }else if( value === 'RENTED' ) {
            return '已租'
        }
    }
    Vue.prototype.houseType = value => {
        if( value == 1 ){
            return '整層住家'
        }else if( value == 2 ) {
            return '套房'
        }else if( value == 3 ) {
            return '雅房'
        }
    }
    Vue.prototype.buildingType = value => {
        if( value == 1 ){
            return '公寓'
        }else if( value == 2 ) {
            return '電梯大樓'
        }else if( value == 3 ) {
            return '透天厝'
        }else if( value == 4 ) {
            return '別墅'
        }
    }
    Vue.prototype.specialType = value => {
        if( value == 0 ){
            return '無'
        }else if( value == 3 ) {
            return '頂樓加蓋'
        }else if( value == 4 ) {
            return '地下室'
        }
    }
    Vue.prototype.transTodoListCat = value => {
        if( value === 'INCOMPLETE' ){
            return '未完善'
        }else if( value === 'UPDATE_TIME' ) {
            return '更新時間'
        }else if( value === 'RESERVATION' ) {
            return '預定'
        }else if( value === 'ADD_BILL' ) {
            return '新增帳單'
        }else if( value === 'ARREARS' ) {
            return '欠款'
        }else if( value === 'DUE_REMINDER' ) {
            return '退租提醒'
        }else if( value === 'NOT_EVALUATE' ) {
            return '尚未評價'
        }else if( value === 'ADD_TASK' ) {
            return '新增委託'
        }
    }
    Vue.prototype.transFilterTagTitle = value => {
        if( value === 'word' ){
            return '搜尋'
        }else if( value === 'group' ) {
            return '業務群組'
        }else if( value === 'member' ) {
            return '業務'
        }else if( value === 'landlord' ) {
            return '房東'
        }else if( value === 'county' ) {
            return '縣市'
        }else if( value === 'district' ) {
            return '區域'
        }else if( value === 'houseType' ) {
            return '出租類型'
        }else if( value === 'buildingType' ) {
            return '房屋類型'
        }else if( value === 'houseStatus' ) {
            return '房源狀態'
        }else if( value === 'noSales' ) {
            return '沒有業務的房源'
        }else if( value === 'noLandlord' ) {
            return '沒有房東的房源'
        }else if( value === 'addressCompleted' ) {
            return '有完整地址的房源'
        }else if( value === 'canAddGroup' ) {
            return '可加入群組的房源'
        }
    }
    Vue.prototype.transFilterTagContent = (item, value) => {
        if(item == 'houseType'){
            return Vue.prototype.houseType(value)
        }else if(item == 'buildingType'){
            return Vue.prototype.buildingType(value)
        }else if(item == 'houseStatus'){
            return Vue.prototype.houseStatus(value)
        }else{
            return value
        }
    }
    Vue.prototype.isReturnTaskBonus = value => {
        if(
            value === 'RETURN_PAID_HOUSE_TASK_BONUS' || 
            value === 'RETURN_PAID_HOUSE_TASK_BONUS_FOR_INCOMPLETE' ||
            value === 'RETURN_PAID_HOUSE_TASK_BONUS_FOR_REJECT' ||
            value === 'RETURN_PAID_HOUSE_TASK_BONUS_FOR_EXPIRE'
            ){
            return true
        }else{
            return false
        }
    }
    Vue.prototype.transType = value => {
        if (value === 'INCOME') {
            return '收入'
        } else if (value === 'EXPENSE') {
            return '支出'
        } else if (value === 'ADVANCE_PAYMENT'){
            return '代墊'
        }
    }
    Vue.prototype.ledgerItemType = value => {
        if (value === 'REPAIR_BILL') {
            return '修繕工程'
        }else if (value === 'RENT') {
            return '租金'
        }else if (value === 'BOOKING_DEPOSIT') {
            return '訂金'
        }else if (value === 'DEPOSIT' ||  value === 'CONTRACT_DEPOSIT'){
            return '押金'
        }else if (value === 'DEPOSIT_FOR_LANDLORD'){
            return '給屋主押金'
        }else if (value === 'DEPOSIT_FOR_TENANT'){
            return '退房客押金'
        }else if (value === 'WATER_BILL'){
            return '水費'
        }else if (value === 'ELECTRICITY_BILL'){
            return '電費'
        }else if (value === 'GAS_BILL'){
            return '瓦斯費'
        }else if (value === 'INTERNET_BILL'){
            return '網路費'
        }else if (value === 'TV_BILL'){
            return '有線電視'
        }else if (value === 'CLEANING_BILL'){
            return '清潔費'
        }else if (value === 'MANAGEMENT_BILL'){
            return '管理費'
        }else if (value === 'PARKING_BILL'){
            return '停車費'
        }else if (value === 'OTHER'){
            return '其他'
        }
    }
    Vue.prototype.transPayWay = value => {
        if( value === 'WALLET' ){
            return '飛豬錢包'
        }else if( value === 'TRANSFER' ) {
            return '匯款轉帳'
        }else if( value === 'TASK_REFUND' ) {
            return '系統退款'
        }else if( value === 'DEPOSIT_FORFEIT' ) {
            return '訂金補償'
        }else{
            return '尚未選擇'
        }
    }
    Vue.prototype.transIncomeType = value => {
        if( value === 'DEPOSIT' ){
            return '收入'
        }else if( value === 'WITHDRAW' ) {
            return '支出'
        }else if( value === 'TRANSFER_OUT' ) {
            return '支出'
        }
    }
    // Vue.prototype.isPositive = value => {
    //     if(value){
    //         let result = Math.sign(value)
    //         if( result == 1 || result == 0){
    //             return true
    //         }else{
    //             return false
    //         }
    //     }
    // }
    Vue.prototype.checkStringLessThanNum = (val, limit) => {
        if(val.length > limit){
            return false
        }else{
            return true
        }
    }
    Vue.prototype.checkLocalStorageHasVal = (name, value) => {
        // console.log('132')
        value = value.toString(); // to prevent infinite loops
        localStorage.setItem(name, value);
        // (function getItem(){
            if (localStorage.getItem(name) == value) {
                // console.log('hasValue')
                return true
            } else {
                // console.log('repeat')
                setTimeout(Vue.prototype.checkLocalStorageHasVal(name, value), 30);
            }
    //    })();
    }
    
    /* 
        @function   name          時間換算
        @function   description   換算時區和format時間
        @param      string		  GMT0_time	        +0時區的時間
        @param      boolean		  getTime	        要不要包含時間的時分 true => 2020-12-16 14:45
        @return     string 				            format後的時間
    */
    Vue.prototype.getFormatDateTime = (GMT0_time, getTime=false) => {
        if(GMT0_time != ''){
            // 計算差幾個時區 => 先寫死+8時區 這邊先註解
            // var local_date = new Date();
            // var local_timezone_offset = local_date.getTimezoneOffset() / 60; // 分鐘轉小時

            // 寫死指定時區為+8台灣時間
            var local_timezone_offset = 0;	

            var GMT_time = new Date(GMT0_time);

            var GMT_hour = GMT_time.getHours();
            GMT_time.setHours(GMT_hour + local_timezone_offset);

            var splitDate = GMT_time.toLocaleString("en-GB", {hour12: false}).split('/');
            var splitTime = GMT_time.toLocaleString("en-GB", {hour12: false}).split(',');

            var formatLocalDate = splitDate[2].split(',')[0] + '-' + splitDate[1] + "-" + splitDate[0];
            var formatLocalTime = formatLocalDate + " " + splitTime[1].split(":")[0] + ":" + splitTime[1].split(":")[1];

            if(getTime){
                return formatLocalTime
            }else{
                return formatLocalDate
            }
        }else{
            return ''
        }
    }
    Vue.prototype.getHouseSetting =  function (arr) {
        let text = ''
        arr.map( (item, index) => {
            if(item.check == true){
                text += item.itemName+ '、'
            }
        })
        return text.substring(0,text.length-1)
    }
    Vue.prototype.markName =  function (name) {
        let nameLen = name.length
        if(nameLen === 2){
            return name.substring(0,1)+'*'
        }else{
            let starCount = nameLen-2
            let star = ''
            for (let i = 0; i < starCount; i++) {
                star += '*'
            }

            return name.substring(0,1)+star+name.substring(nameLen-1)
        }        
    }
    Vue.prototype.compressWord =  function (word, len) {
        return word.substring(0,len-2)+'...'
    }
    Vue.prototype.getPayWayWord =  (value) => {
        if( value === true || value == 'date'){
            return '每月固定幾號繳交房租'
        }else if( value === false || value == 'contract' ) {
            return '依合約起租日繳交房租'
        }else{
            return '繳款方式'
        }
    }
    Vue.prototype.getRentPayDayWord = (value) => {
        if(value){
            if(value !== -1){
                return '每月 '+value+' 號'
            }else{
                return '每月最後一天'
            }
        }else{
            return '請選擇日期'
        }
    }
    Vue.prototype.checkIsNum = (num) => {
        let numerical = /^[0-9]*$/
        return numerical.test(num)?true:false
    }
};




// WEBPACK FOOTER //
// ./src/assets/js/global.js